import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { USER_ROLE_LABELS, type UserRole } from 'shared';
import { useCurrentUser } from '@/hooks/useAuth';

export default function ProfilePage() {
  const { data, isLoading } = useCurrentUser();
  const user = data?.user;
  const coordinator = data?.coordinator;

  if (isLoading) {
    return (
      <>
        <Helmet>
          <title>Perfil | DIGGER</title>
        </Helmet>
        <div className="flex items-center justify-center h-64" role="status" aria-live="polite">
          <div className="text-muted-foreground">A carregar...</div>
        </div>
      </>
    );
  }

  const roleLabel = user?.role ? USER_ROLE_LABELS[user.role as UserRole] ?? user.role : '';
  const memberSince = user?.createdAt ? new Date(user.createdAt).toLocaleDateString('pt-PT') : '';

  return (
    <>
      <Helmet>
        <title>Perfil | DIGGER</title>
      </Helmet>
      <div className="space-y-6">
        <div>
          <h1 className="text-2xl font-bold text-foreground">Perfil</h1>
          <p className="text-muted-foreground mt-1">Os dados da tua conta</p>
        </div>

        <div className="card">
          <div className="p-6 border-b border-border">
            <h2 className="text-lg font-semibold text-foreground">Informação da conta</h2>
          </div>
          <div className="p-6 space-y-6">
            <div className="grid gap-6 md:grid-cols-2">
              <div>
                <label htmlFor="profile-id" className="label">ID de utilizador</label>
                <input
                  id="profile-id"
                  type="text"
                  className="input mt-1"
                  defaultValue={user?.id ?? ''}
                  readOnly
                />
              </div>
              <div>
                <label htmlFor="profile-name" className="label">Nome completo</label>
                <input
                  id="profile-name"
                  type="text"
                  className="input mt-1"
                  defaultValue={user?.name}
                  readOnly
                />
              </div>
              <div>
                <label htmlFor="profile-email" className="label">Email</label>
                <input
                  id="profile-email"
                  type="email"
                  className="input mt-1"
                  defaultValue={user?.email}
                  readOnly
                />
              </div>
              <div>
                <label htmlFor="profile-phone" className="label">Telefone</label>
                <input
                  id="profile-phone"
                  type="tel"
                  className="input mt-1"
                  defaultValue={coordinator?.phone ?? ''}
                  readOnly
                />
              </div>
              <div>
                <label htmlFor="profile-role" className="label">Função</label>
                <input
                  id="profile-role"
                  type="text"
                  className="input mt-1"
                  defaultValue={roleLabel}
                  readOnly
                />
              </div>
              <div>
                <label htmlFor="profile-since" className="label">Membro desde</label>
                <input
                  id="profile-since"
                  type="text"
                  className="input mt-1"
                  defaultValue={memberSince}
                  readOnly
                />
              </div>
            </div>
          </div>
        </div>

        <div className="card">
          <div className="p-6 border-b border-border">
            <h2 className="text-lg font-semibold text-foreground">Segurança</h2>
          </div>
          <div className="p-6">
            <Link to="/admin-users" className="btn-outline">
              Alterar password
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
